import BasicModel from "./basic_model";

export default class Indicator extends BasicModel {

  r = function () {
    return 8 * this.context.scale;
  }

  render = function () {
    this.setupContext();

    const x = this.x();
    const y = this.y();

    this.context.beginPath();
    this.context.arc(x, y, this.r(), 0, 2 * Math.PI, true);
    this.context.fillStyle = "rgba(0, 0, 0, 1)";
    this.context.fill();

    this.context.font = 11 * this.context.scale + "px Arial";
    this.context.fillStyle = "rgba(255, 255, 255, 1)";
    this.context.fillText(this.marker, x - 3.5 * this.context.scale, y + 3.5 * this.context.scale);

    this.resetContext()
  }

  boundingBox = function () {
    const r = this.r();

    return {
      x: this.x() - r,
      y: this.y() - r,
      w: r * 2,
      h: r * 2
    }
  }

}


